module.exports = __webpack_public_path__ + "img/logo.6b2e71c6.png";